export default "__VITE_ASSET__23cd2d4f__"